/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Content_Title_Default_QuestionInputs */

const en_course_content_title_default_question = /** @type {(inputs: Course_Content_Title_Default_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const ja_course_content_title_default_question = /** @type {(inputs: Course_Content_Title_Default_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題`)
};

const fr_course_content_title_default_question = /** @type {(inputs: Course_Content_Title_Default_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const de_course_content_title_default_question = /** @type {(inputs: Course_Content_Title_Default_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage`)
};

/**
* | output |
* | --- |
* | "Question" |
*
* @param {Course_Content_Title_Default_QuestionInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_content_title_default_question = /** @type {((inputs?: Course_Content_Title_Default_QuestionInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Content_Title_Default_QuestionInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_content_title_default_question(inputs)
	if (locale === "ja") return ja_course_content_title_default_question(inputs)
	if (locale === "fr") return fr_course_content_title_default_question(inputs)
	return de_course_content_title_default_question(inputs)
});